if(!customElements.get('cart-upsell-swiper')) {
  customElements.define(
    'cart-upsell-swiper',
    class CartUpsellSwiper extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
      }
    
      connectedCallback() {
        this.swiperProperties = {
          slidesPerView: 1.2,
          spaceBetween: 8,
          pagination: {
            el: this.swiperElements.pagination,
            type: "fraction",
          },
          navigation: {
            nextEl: this.swiperElements.next,
            prevEl: this.swiperElements.prev,
          },
        };
    
        this.initSlider(this.swiperElements.swiper, this.swiperProperties);
      }
    
      initSlider(swiper, properties) {
        this.swiper = new Swiper(swiper, properties);
        return this.swiper;
      }
    
      get swiperElements() {
        const elements = {
          swiper: this.querySelector(`[id^="CartUpsellSwiper-${this.sectionId}"]`),
          prev: this.querySelector(`[id^="CartUpsellSwiper-prev-${this.sectionId}"]`),
          next: this.querySelector(`[id^="CartUpsellSwiper-next-${this.sectionId}"]`),
          pagination: this.querySelector(`[id^="CartUpsellSwiper-pagination-${this.sectionId}"]`),
        }
    
        return elements;
      }
    }
  )
}